import { app_perm_set_hdr_RowClass, app_perm_template_hdr_RowClass, app_perm_template_line_RowClass, app_perm_template_line_RowInterface } from "blg-akaun-ts-lib";

export interface PermissionTemplateContainer {
    app_perm_template_hdr: app_perm_template_hdr_RowClass;
    app_perm_template_lines: Array<app_perm_template_line_RowInterface>;
    createdBySubjectName: string;
    numPerms: number;
}
export class PermissionWizardModel {
    app_perm_template_hdr: app_perm_template_hdr_RowClass = new app_perm_template_hdr_RowClass();
    app_perm_template_lines: Array<app_perm_template_line_RowInterface>;
    //permWizardLines: PermWizardLine[] = []
}

export class PermWizardLine {
    app_perm_template_line: app_perm_template_line_RowClass = new app_perm_template_line_RowClass();
    default_target_view_name: string;
    default_target_hdr_name: string;
}
